"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _icons = _interopRequireDefault(require("icons/icons"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var ErrorMessage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ErrorMessage, _PureComponent);

  function ErrorMessage() {
    (0, _classCallCheck2.default)(this, ErrorMessage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ErrorMessage).apply(this, arguments));
  }

  (0, _createClass2.default)(ErrorMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          heading = _this$props.heading,
          icon = _this$props.icon,
          message = _this$props.message;
      return _react.default.createElement("div", {
        className: "text-center error-message"
      }, _react.default.createElement(_UIIcon.default, {
        name: icon,
        size: "xl",
        className: "m-bottom-4"
      }), heading ? _react.default.createElement("h2", null, heading) : null, message ? _react.default.createElement("p", null, message) : null);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        icon: _react.PropTypes.oneOf(Object.values(_icons.default || {})).isRequired,
        heading: _react.PropTypes.node,
        message: _react.PropTypes.node
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        icon: 'settings'
      };
    }
  }]);
  return ErrorMessage;
}(_react.PureComponent);

exports.default = ErrorMessage;
module.exports = exports.default;